<div class="container-fluid py-3 bg-light">
  <div class="card shadow-sm border-0 mb-3">
    <div class="card-body d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
      <div>
        <!-- <h4 class="mb-1 fw-semibold">Issue RFP</h4> -->
         <h4 class="mb-1 fw-semibold">{{stepDetails?.name}}</h4>
        <h6 class="mb-2 text-primary fw-semibold">[{{ proposalName }}]</h6>
        <div class="d-flex align-items-center gap-2">
          <span class="text-muted text-uppercase small fw-semibold">Status</span>
          <span class="badge rounded-pill px-3 py-2" [ngClass]="{'bg-secondary': stepDetails?.step_status == 0, 'bg-success': stepDetails?.step_status == 'approved', 'bg-warning text-dark': stepDetails?.step_status == 'recommended', 'bg-info text-dark': stepDetails?.step_status == 'initiated'}">{{ stepDetails?.step_status == 0 ? 'Initiation Pending' : (stepDetails?.step_status | uppercase) }}</span>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-md-end gap-2">
        <!-- <button type="button" class="btn btn-outline-secondary btn-sm px-3" (click)="generatePDF()"><i class="pi pi-file-pdf me-1"></i> PDF</button> -->
        <ng-container *ngIf="stepDetails?.can_edit"><button type="button" class="btn btn-primary btn-sm px-3" (click)="routeConfig.emit({ isRouteConfig: true })" [disabled]="RFPForm?.invalid"><i class="pi pi-save me-1"></i> Save / Forward / Route Config</button></ng-container>
      </div>
    </div>
  </div>
  <form [formGroup]="RFPForm" (ngSubmit)="onRFPSubmit()">
    <div *ngIf="schemeType == 'rev' "  class="card shadow-sm border-0">
      <div class="card-body">
        <div  class="mb-2 border bg-white">
          <div class="d-flex justify-content-between align-items-center p-4 border-bottom bg-body-tertiary" (click)="toggleSection('uploads')" style="cursor: pointer;">
            <div class="d-flex align-items-center gap-2">
              <span class="badge bg-primary rounded-pill">&nbsp;</span>
              <span class="text-uppercase small fw-semibold text-secondary">Document Uploads</span>
            </div>
            <i class="pi" [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div *ngIf="expandedSections['uploads']" class="p-3">
            <app-upload-document [title]="'Issuance Of RFP Document'" [isEditable]="stepDetails?.can_edit"></app-upload-document>
          </div>
        </div>
        <div  class="mb-2 border  bg-white">
          <div class="d-flex justify-content-between align-items-center p-4 border-bottom bg-body-tertiary" (click)="toggleSection('basicInfo')" style="cursor: pointer;">
            <div class="d-flex align-items-center gap-2">
              <span class="badge bg-primary rounded-pill">&nbsp;</span>
              <span class="text-uppercase small fw-semibold text-secondary">RFP Details</span>
            </div>
            <i class="pi" [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div *ngIf="expandedSections['basicInfo']" class="p-3">
            <div class="row g-3">
              <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="upload_rfp_date" class="bg-primary text-white fw-semibold p-3 w-50">RFP Uploading Date <span class="text-warning">*</span></span>
                <input pInputText id="upload_rfp_date" type="date" formControlName="upload_rfp_date" autocomplete="off" class="form-control form-control-sm mt-1" />
              </div>
              <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="tenderMode" class="bg-primary text-white fw-semibold p-3 w-50">Tender Mode <span class="text-warning">*</span></span>
                <div class="w-50">
                  <p-dropdown inputId="tenderMode" [options]="tenderModes" formControlName="mode_tendor" optionLabel="label" optionValue="value" placeholder="Select Mode" [autoDisplayFirst]="false" [style]="{ width: '100%' }" styleClass="w-100"></p-dropdown>
                </div>
              </div>
              <div class="col-md-6 d-flex align-items-center gap-2">
                <span class="bg-primary text-white fw-semibold p-2 w-50">Pre-Bid Meeting?</span>
                <div class="w-50">
                  <div class="d-flex align-items-center gap-3">
                    <p-radioButton
                      name="has_pre_bid"
                      [value]="true"
                      formControlName="has_pre_bid"
                      class="border-2 border-gray-500 p-1 rounded-full"
                      inputId="preBidYes"
                    ></p-radioButton>
                    <label class="form-check-label small" for="preBidYes">Yes</label>
                    <p-radioButton
                      name="has_pre_bid"
                      [value]="false"
                      formControlName="has_pre_bid"
                      class="border-2 border-gray-500 p-1 rounded-full"
                      inputId="preBidNo"
                    ></p-radioButton>
                    <label class="form-check-label small" for="preBidNo">No</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="RFPForm.get('has_pre_bid')?.value" class="mb-2 border  bg-white">
          <div class="d-flex justify-content-between align-items-center p-4 border-bottom bg-body-tertiary" (click)="toggleSection('MeetingDetails')" style="cursor: pointer;">
            <div class="d-flex align-items-center gap-2">
              <span class="badge bg-primary rounded-pill">&nbsp;</span>
              <span class="text-uppercase small fw-semibold text-secondary">Pre-Bid Meeting Details</span>
            </div>
            <i class="pi" [ngClass]="expandedSections['MeetingDetails'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div *ngIf="expandedSections['MeetingDetails']" class="p-3">
            <div class="row g-3">
              <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="pre_bid_date" class="bg-primary text-white fw-semibold p-3 w-50">Pre-Bid Meeting Date <span class="text-warning">*</span></span>
                <input pInputText id="pre_bid_date" type="date" formControlName="pre_bid_date" autocomplete="off" class="form-control form-control-sm mt-1" />
              </div>
             <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="pre_bid_time" class="bg-primary text-white fw-semibold p-3 w-50">Pre-Bid Meeting Time <span class="text-warning">*</span></span>
                <input pInputText id="pre_bid_time" type="time" formControlName="pre_bid_time" autocomplete="off" class="form-control form-control-sm mt-1" />
              </div>
            </div>
            <div class="row g-3 mt-3">
               <!-- <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="pre_bid_time" class="bg-primary text-white fw-semibold p-3 w-50">Pre-Bid Meeting Time <span class="text-warning">*</span></span>
                <input pInputText id="pre_bid_time" type="time" formControlName="pre_bid_time" autocomplete="off" class="form-control form-control-sm mt-1" />
              </div> -->

               <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="pre_bid_venue" class="bg-primary text-white fw-semibold p-3 w-50">Pre-Bid Venue <span class="text-warning">*</span></span>
                <input pInputText id="pre_bid_venue" type="text" formControlName="pre_bid_venue" autocomplete="off" class="form-control form-control-sm mt-1" placeholder="Enter venue" />
              </div>
            </div>
          </div>
        </div>
        <div class="mb-2 border  bg-white">
          <div class="d-flex justify-content-between align-items-center p-4 border-bottom bg-body-tertiary" (click)="toggleSection('Timeline')" style="cursor: pointer;">
            <div class="d-flex align-items-center gap-2">
              <span class="badge bg-primary rounded-pill">&nbsp;</span>
              <span class="text-uppercase small fw-semibold text-secondary">Tender Timeline</span>
            </div>
            <i class="pi" [ngClass]="expandedSections['Timeline'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div *ngIf="expandedSections['Timeline']" class="p-3">
            <div class="row g-3">
              <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="bid_submission_date" class="bg-primary text-white fw-semibold p-3 w-50">Bid Submission Date <span class="text-warning">*</span></span>
                <input pInputText id="bid_submission_date" type="date" formControlName="bid_submission_date" autocomplete="off" class="form-control form-control-sm mt-1 w-50" />
              </div>
              <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="tendor_opening_date" class="bg-primary text-white fw-semibold p-3 w-50">Tender Opening Date <span class="text-warning">*</span></span>
                <input pInputText id="tendor_opening_date" type="date" formControlName="tendor_opening_date" autocomplete="off" class="form-control form-control-sm mt-1 w-50" />
              </div>
              <div class="col-md-6 d-flex align-items-center gap-2">
                <span for="tendor_opening_time" class="bg-primary text-white fw-semibold p-3 w-50">Tender Opening Time <span class="text-warning">*</span></span>
                <input pInputText id="tendor_opening_time" type="time" formControlName="tendor_opening_time" autocomplete="off" class="form-control form-control-sm mt-1 w-50" />
              </div>
              <div class="col-md-6 d-flex gap-2">
                <label class="bg-primary text-white p-2 ">Tender Opening Venue <b class="text-warning">*</b></label>
                <input inputId="tendor_opening_venue" formControlName="tendor_opening_venue" [disabled]="true" class="w-full" />
                
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3 border bg-white" *ngIf="schemeType !='rev'" >
          <div class="d-flex justify-content-between align-items-center p-4 border-bottom bg-body-tertiary" (click)="toggleSection('detailedInfo')" style="cursor: pointer;">
            <div class="d-flex align-items-center gap-2">
              <span class="badge bg-primary rounded-pill">&nbsp;</span>
              <span class="text-uppercase small fw-semibold text-secondary">Detailed Information</span>
            </div>
            <i class="pi" [ngClass]="expandedSections['detailedInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div *ngIf="expandedSections['detailedInfo']" class="p-3">
            <div class="bg-primary text-white fw-semibold p-2">Brief Description / Technical Details <span class="text-warning">*</span></div>
              <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
          </div>
        </div>
        
      </div>
    </div>
    <div  *ngIf="schemeType == 'tdf' || schemeType == 'makeII' || schemeType == 'makeI' || schemeType == 'makeIII'" class="card shadow-sm border-0 p-3">
        <app-upload-document [title]="stepDetails?.name + ' Document'" [isEditable]="stepDetails?.can_edit"></app-upload-document>

        <div class="mb-3 mt-4">
            <div class="bg-primary text-white fw-semibold p-3">Remarks </div>
              <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
        </div>

    </div>
  </form>
</div>
